import { TemplateLayoutData } from '../template/template-layout.data';
import { SheetTitleData } from './sheet-title.data';
import { SheetLogoData } from './sheet-logo.data';
import { SheetLogoPrintData } from './sheet-logo-print.data';
import { SheetURLData } from './sheet-url.data';
import { SheetDateData } from './sheet-date.data';
import { ContextData } from 'src/app/data/context.data';

export class SheetProperties {

  // properties
  private _width:number;
  private _height:number;
  private _reference:string;
  private _layouts:Array<TemplateLayoutData>;
  private _title:SheetTitleData;
  private _logo:SheetLogoData;
  private _logoPrint:SheetLogoPrintData;
  private _url:SheetURLData;
  private _date:SheetDateData;
  private _tipId:number;

  // data
  private _data:any;

  constructor(data:any = null) {
    if (data) {
      this.data = data;
    }
  }

  /**
	 * data
	 */
  public set data(value: any) {
    this._data = value;

		this._reference = this._data.reference;

    this._tipId = this._data.tipsId;
    this._width = this._data.width;
		this._height = this._data.height;

		this._layouts = [];
    for (var i:number = 0; i < this._data.labels.length; i++) {
      this._layouts.push(new TemplateLayoutData(this._data.labels[i]));
    }

    if (this._data.printingChart){

      if (this._data.printingChart.title) {
        this._title = new SheetTitleData(this._data.printingChart.title);
      }

      if (this._data.printingChart.mainLogo) {
        this._logo = new SheetLogoData(this._data.printingChart.mainLogo);
      }

      if (this._data.printingChart.printLogo) {
        this._logoPrint = new SheetLogoPrintData(this._data.printingChart.printLogo);
      }

      if (this._data.printingChart.link) {
        this._url = new SheetURLData(this._data.printingChart.link);
      }

      if (this._data.printingChart.date) {
        this._date = new SheetDateData(this._data.printingChart.date);
      }

    }


  }

  /**
   * Layout
   */
  public get layouts():Array<TemplateLayoutData> {
    return this._layouts;
  }

  public set layouts(value:Array<TemplateLayoutData>) {
    this._layouts = value;
  }

  /**
   * Size
   */
  public get width():number {
    return this._width;
  }
  public get pixelsWidth():number {
    return this.width * ContextData.MM_TO_PIXELS;
  }

  public get height():number {
    return this._height;
  }
  public get pixelsHeight():number {
    return this.height * ContextData.MM_TO_PIXELS;
  }


  /**
   * Size
   */
  public get reference():string {
    return this._reference;
  }

  /**
   * Properties
   */
  public get title():SheetTitleData {
    return this._title;
  }

  public get logo():SheetLogoData {
    return this._logo;
  }

  public get logoPrint():SheetLogoPrintData {
    return this._logoPrint;
  }

  public get url():SheetURLData {
    return this._url;
  }

  public get date():SheetDateData {
    return this._date;
  }

  public get tipId():number {
    return this._tipId;
  }

  /**
   * Cleanup
   */
  public cleanup():void {
    if (this._title) {
      this._title.cleanup();
    }
    this._title = null;

    if (this._logo) {
      this._logo.cleanup();
    }
    this._logo = null;

    if (this._logoPrint) {
      this._logoPrint.cleanup();
    }
    this._logoPrint = null;

    if (this._url) {
      this._url.cleanup();
    }
    this._url = null;

    if (this._date) {
      this._date.cleanup();
    }
    this._date = null;

    this._data = null;
    this._layouts = null;
  }

}
